import EmptyObjectCreator from "../../../output/assets/objects/empty-object-creator.js";

class ThreeEmptyObjectCreator extends EmptyObjectCreator {
    constructor(EmptyObject) {
        super();
        this._EmptyObject = EmptyObject;
    }

    create() {
        const EmptyObject = this._EmptyObject;
        return new EmptyObject();
    }

    dispose(object) {}
}

export default ThreeEmptyObjectCreator;
